import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaSaDepositosNuevo', {
    template: template,
    controller: NominaSaDepositosNuevoComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      pendiente: '<',
      onChange: '&',
    },
  })

function NominaSaDepositosNuevoComponent(NominaSaCuentasbancarias, NominaSaDepositos, $filter) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.agregar = agregar
  $ctrl.cancelar = cancelar

  function $onInit() {
    $ctrl.agregando = false
    $ctrl.actualizando = false
  }

  function aceptar() {
    let data = {
      id_cuenta_sa: $ctrl.data.cuenta_sa.id_cuenta,
      fecha_deposito: $ctrl.data.fecha_deposito,
      importe: $ctrl.data.importe,
    }

    $ctrl.actualizando = true

    return NominaSaDepositos.post($ctrl.idEmpresa, $ctrl.idNomina, data)
      .then(function (response) {
        $ctrl.onChange({$event: {data: response.data}})
        $ctrl.agregando = false
      })
      .finally(function () {
        $ctrl.actualizando = false
      })
  }

  function agregar() {
    $ctrl.agregando = true
    $ctrl.data = undefined

    if (!$ctrl.promise)
      $ctrl.promise = NominaSaCuentasbancarias.get($ctrl.idEmpresa, $ctrl.idNomina)
        .then(function (response) {
          $ctrl.cuentasBancarias = $filter('orderBy')(response.data, ['moneda', 'banco', 'cuenta'])
          $ctrl.cuentaPredeterminada = $ctrl.cuentasBancarias.find(function (item) {
            return item.predeterminado
          })
        })

    $ctrl.promise.then(function () {
      $ctrl.data = {
        cuenta_sa: $ctrl.cuentaPredeterminada,
        fecha_deposito: new Date(),
        importe: $ctrl.pendiente,
      }
    })
  }

  function cancelar() {
    $ctrl.agregando = false
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/sa/depositos/nuevo/component.js